export const dataModel = {
  url: "/api/publicationslisting",
  initialResults: 15, // number of results on first page
  perPage: 5, // number of additional results when load more is clicked
  loadMore: true,
  loadMoreText: "More Research",
  includeSearchBar: true, // hide search bar if false
  searchPlaceholder: "Search Research", // placeholder on search bar
  showFacetsLabel: "Filters",
  clearAllLabel: "Reset",
  facetKeys: ["publicationType"],
  columnOneText: "Type/Date", // column 1 header
  columnTwoText: "Title/Author", // column 2 header
  excludeFromQueryString: true,
  header: "<h2>Publications</h2>",
  description: `
    Nulla fringilla fringilla nunc nec feugiat.
    <a href="#1">Fusce congue,</a> libero et tempor ultricies, eros erat
    consequat diam, at fermentum orci est non odio. Fusce quis neque in
    quam dignissim placerat sed eget dolor.
  `,
};

export const dataQuery = {
  pageId: "7d7c07a0-4748-4e16-a1f3-28b1af3f2a3a",
  listingId: "dfa28f3c-f7b7-45bd-b789-91cd2a2547cd",
  showType: true, // determines whether the type is shown in first column
};

export const mockApiResponse = {
  request: {
    pageId: "7d7c07a0-4748-4e16-a1f3-28b1af3f2a3a",
    page: 1,
    perPage: 5,
    sortBy: "date",
    sortOrder: "desc",
    queryParameters: {},
  },
  totalResults: 8436,
  results: [
    {
      key: "{33D4A08D-097A-11EB-9020-0242AC160003}",
      type: "Working Paper",
      year: "2022",
      title: "Wealth Dynamics in Communities",
      journal: "",
      authors:
        "<a href='/mba-programs.aspx'>Daniel Barron</a>, yingni guo, Bryony Reich",
      url: "/velir-test/publications/2022/wealth-dynamics-in-communities.aspx",
    },
    {
      key: "{DEC91732-1A96-11E8-91BE-0242AC160003}",
      type: "Journal Article",
      year: "2022",
      title:
        "How Voluntary Information Sharing Systems Form: Evidence from a U.S. Commercial Credit Bureau",
      journal: "Journal of Financial Economics",
      authors: "Jose Maria Liberti, Andrew Sutherland, Jason Sturgess",
      url: "/velir-test/publications/2022/how-voluntary-information-sharing-systems-form-evidence-from-a-us-commercial-credit-bureau.aspx",
    },
    {
      key: "{C7803B02-42BA-11EC-8551-0242AC160003}",
      type: "Journal Article",
      year: "2022",
      title: "Teaching entrepreneurial negotiation",
      journal: "Negotiation Journal",
      authors: "Stephen Humphrey, Robert Macy, Cynthia Wang",
      url: "/velir-test/publications/2022/teaching-entrepreneurial-negotiation.aspx",
    },
    {
      key: "{46EE403B-1689-11E8-91BE-0242AC160003}",
      type: "Journal Article",
      year: "2022",
      title:
        "Meta-analysis of Studies with Multiple Contrasts and Differences in Measurement Scales",
      journal: "Journal of Consumer Psychology",
      authors: "Blake McShane, Ulf Bockenholt",
      url: "/velir-test/publications/2022/meta-analysis-of-studies-with-multiple-contrasts-and-differences-in-measurement-scales.aspx",
    },
    {
      key: "{0C1DC68A-5BA9-11E8-91BE-0242AC160003}",
      type: "Journal Article",
      year: "2022",
      title: "Complex Disclosure",
      journal: "Management Science",
      authors: "Ginger Jin, Michael Luca, Daniel Martin",
      url: "/velir-test/publications/2022/complex-disclosure.aspx",
    },
    {
      key: "{F05AB21C-A085-11EC-91CC-0242AC160003}",
      type: "Journal Article",
      year: "2022",
      title:
        "Connect or protect? Social class and self-protection in romantic relationships.",
      journal: "Journal of Personality and Social Psychology",
      authors: "Eli J. Finkel, Emery Lydia",
      url: "/velir-test/publications/2022/connect-or-protect-social-class-and-self-protection-in-romantic-relationships.aspx",
    },
    {
      key: "{76638E3D-FFD5-11E9-85CA-0242AC160003}",
      type: "Journal Article",
      year: "2022",
      title: "Expected Profits and the Scientific Novelty of Innovation",
      journal: "RAND Journal of Economics",
      authors: "David Dranove, Craig Garthwaite, Manuel Hermosilla",
      url: "/velir-test/publications/2022/expected-profits-and-the-scientific-novelty-of-innovation.aspx",
    },
    {
      key: "{C092BDE3-39F7-11E9-91BE-0242AC160003}",
      type: "Journal Article",
      year: "2022",
      title: "Optimal Monetary Policy in Production Networks",
      journal: "Econometrica",
      authors: "Jennifer La'O, Alireza Tahbaz-Salehi",
      url: "/velir-test/publications/2022/optimal-monetary-policy-in-production-networks.aspx",
    },
    {
      key: "{18991DA8-A14E-11EC-91CC-0242AC160003}",
      type: "Journal Article",
      year: "2022",
      title:
        "Leadership in an ideological age: What social psychology and relationship science can teach us about conflict in the workplace—and how to manage it",
      journal: "Harvard Business Review",
      authors: "Eli J. Finkel, Nour Kteily",
      url: "/velir-test/publications/2022/leadership-in-an-ideological-age-what-social-psychology-and-relationship-science-can-teach-us-about-conflict-in-the-workplaceand-how-to-manage-it.aspx",
    },
    {
      key: "{AD633085-A14C-11EC-91CC-0242AC160003}",
      type: "Journal Article",
      year: "2022",
      title: "Mate Evaluation Theory",
      journal: "Psychological Review",
      authors: "Eli J. Finkel, Paul Eastwick, Samantha Joel",
      url: "/velir-test/publications/2022/mate-evaluation-theory.aspx",
    },
    {
      key: "{5D4C0C8E-C3C6-11EB-BCEB-0242AC160003}",
      type: "Journal Article",
      year: "2022",
      title: "Characteristic-based Returns: Alpha or Smart Beta?",
      journal: "Journal of Investment Management",
      authors: "Robert Korajczyk, Soohun Kim, Andreas Neuhierl",
      url: "/velir-test/publications/2022/characteristic-based-returns-alpha-or-smart-beta.aspx",
    },
    {
      key: "{3A3DF498-B1A0-11EB-BCEB-0242AC160003}",
      type: "Working Paper",
      year: "2022",
      title:
        "Measuring Benefits from New Products in Markets with Information Frictions",
      journal: "",
      authors: "Ilya Morozov",
      url: "/velir-test/publications/2022/measuring-benefits-from-new-products-in-markets-with-information-frictions.aspx",
    },
    {
      key: "{1CB08AB9-B1A0-11EB-BCEB-0242AC160003}",
      type: "Working Paper",
      year: "2022",
      title: "Welfare Effects of Personalized Rankings",
      journal: "",
      authors: "Ilya Morozov, Robert Donnelly, Ayush Kanodia",
      url: "/velir-test/publications/2022/welfare-effects-of-personalized-rankings.aspx",
    },
    {
      key: "{40F262DC-3AA4-11E9-91BE-0242AC160003}",
      type: "Journal Article",
      year: "2022",
      title:
        "The Good-on-Paper Effect: How the Decision Context Influences Virtuous Behavior",
      journal: "Marketing Science",
      authors: "Rima Toure-Tillery, Lili Wang",
      url: "/velir-test/publications/2022/the-good-on-paper-effect-how-the-decision-context-influences-virtuous-behavior.aspx",
    },
    {
      key: "{A8E04A0F-3B93-11E9-91BE-0242AC160003}",
      type: "Working Paper",
      year: "2022",
      title:
        "The Effects of Computer-Assisted Learning on Students' Long-Term Development",
      journal: "",
      authors: "Nicola Bianchi, Yi Lu, Hong Song",
      url: "/velir-test/publications/2022/the-effects-of-computer-assisted-learning-on-students-long-term-development.aspx",
    },
  ],
  facets: [
    {
      id: "publicationType",
      label: "Type",
      values: [
        {
          id: "Book",
          name: "Book",
          count: 287,
          selected: false,
          childValues: [],
        },
        {
          id: "Book Chapter",
          name: "Book Chapter",
          count: 1017,
          selected: false,
          childValues: [],
        },
        {
          id: "Journal Article",
          name: "Journal Article",
          count: 6153,
          selected: false,
          childValues: [],
        },
        {
          id: "Working Paper",
          name: "Working Paper",
          count: 979,
          selected: false,
          childValues: [],
        },
      ],
      childGroups: [],
    },
    {
      id: "departments",
      label: "Departments",
      values: [
        {
          id: "Managerial Economics & Decision Sciences",
          name: "Managerial Economics & Decision Sciences",
          count: 690,
          selected: false,
          childValues: [],
        },
        {
          id: "Marketing",
          name: "Marketing",
          count: 1252,
          selected: false,
          childValues: [],
        },
        {
          id: "Management & Organizations",
          name: "Management & Organizations",
          count: 1204,
          selected: false,
          childValues: [],
        },
        {
          id: "Finance",
          name: "Finance",
          count: 776,
          selected: false,
          childValues: [],
        },
        {
          id: "Strategy",
          name: "Strategy",
          count: 769,
          selected: false,
          childValues: [],
        },
        {
          id: "Accounting Information & Management",
          name: "Accounting Information & Management",
          count: 330,
          selected: false,
          childValues: [],
        },
        {
          id: "Operations",
          name: "Operations",
          count: 300,
          selected: false,
          childValues: [],
        },
        {
          id: "John L. Ward Center for Family Enterprises",
          name: "John L. Ward Center for Family Enterprises",
          count: 62,
          selected: false,
          childValues: [],
        },
      ],
      childGroups: [],
    },
  ],
};
